export const StatusUser = {
	Unknow: 0,
	Online: 1,
	Offline: 2,
}